import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import {
    Gift,
    giftRecordSliceActions,
    GiftRecordState,
} from '@/modules/report/slice/giftRecord';
import { CMDSpGiftLogQuery, ICommand } from '../../live';
import { getGiftRecordReportState } from '@/modules/report/selector';
import store from '@/store/store';
import { AbstractHandler } from '../AbstractHandler';
import moment from 'moment';

export class CMDSpGiftLogQueryHandler extends AbstractHandler {
    _command: CMDSpGiftLogQuery;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDSpGiftLogQuery;
    }
    handle(dispatch: Dispatch<AnyAction>): void {
        const state = store.getState();
        const { records, total } = getGiftRecordReportState(state);

        const newRecords: GiftRecordState['records'] = JSON.parse(
            JSON.stringify(records)
        );

        for (let b of this._command.Gift) {
            if (Object.keys(newRecords.gifts).length >= total) break;
            // the UTCSecond has been include the timezone (UTC+8), so do not do any change before server has change the timestamp to UTC
            const m = moment.unix(b.UTCSecond).utc(false);
            const d = m.format('yyyy-MM-DD');
            const t = m.format('HH:mm:ss');

            const gift = {} as Gift;

            gift.HostID = b.HostID;
            gift.GameType = b.GameType;
            const gameCount = b.GameCount;
            gift.Shoes = Math.floor(gameCount / 10000);
            gift.Round = gameCount % 10000;
            gift.GameCount = gameCount;
            gift.DealerName = b.DealerName;
            gift.ID = b.ID;
            gift.Balance = b.Balance;
            gift.GiftAmount = b.GiftAmount;
            gift.GiftType = b.GiftType;
            gift.Date = d;
            gift.Time = t;

            newRecords.gifts.push(gift);
            newRecords.totalAmount += gift.GiftAmount;
        }

        dispatch(
            giftRecordSliceActions.updateRecord({
                records: newRecords,
            })
        );
    }
}
